import { isSafari } from "@helpers/fullScreenHelper";
import { useState } from "react";
import { Translate } from "react-i18nify";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RefreshIcon } from "../../../common/assets";
import { LBtn } from "../../../common/components/LBtn";
import { LSubTitle } from "../../../common/components/LSubtitle";
import { LTitle } from "../../../common/components/LTitle";
import { NavItems } from "../../../common/helpers/navigation";
import { updateAssessment } from "../../../common/store/assessmentSlice";
import { setSiltentTimeout } from "../../../common/store/assessmentFlowSlice";
import { useApi } from "../../../services/useApi";
import { AssessmentShell } from "../components/AssessmentShell";

export const AssessmentBegin = (): JSX.Element => {
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const { getAssessment } = useApi();
    const dispatch = useAppDispatch();

    const assessmentInitialized = useAppSelector((x) => x.assessment);
    const assessmentTimeout = useAppSelector((x) => x.globalSettings.assessmentTimeout);

    const handleNavigateToStart = (): void => {
        navigate(NavItems.Assessments.Instruction.path);
    };

    const handleBegin = async (): Promise<void> => {
        setLoading(true);

        if (isSafari) {
            const soundEffect = new Audio();
            soundEffect.autoplay = true;
            soundEffect.src =
                "data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV";
        }
        try {
            const assessment = await getAssessment(assessmentInitialized.id ?? 0);

            assessment.id = assessmentInitialized.id;

            dispatch(updateAssessment(assessment));
        } finally {
            setLoading(false);
        }

        dispatch(setSiltentTimeout(assessmentTimeout));

        navigate(NavItems.Assessments.AssessmentPresentTargets.path);
    };

    return (
        <AssessmentShell excludeUnauthenticatedMenu>
            <div>
                <LTitle color="has-text-dark-blue">
                    <Translate value="assessments.rstart" />
                </LTitle>
                <div className="mt-6">
                    <LSubTitle size="4" color="has-text-primary-blue">
                        <Translate value="assessments.replayInstructionVideo" />
                    </LSubTitle>
                </div>
                <div className="my-4">
                    <LBtn variation="unstyled" onClick={handleNavigateToStart} ariaLabel="replay">
                        <RefreshIcon />
                    </LBtn>
                </div>
                <div className="my-6">
                    <LBtn loading={loading} onClick={handleBegin} isBold>
                        <Translate value="assessments.begin" />
                    </LBtn>
                </div>
                <div className="is-size-4 has-text-dark-blue">
                    <Translate value="assessments.beginWarning1" />
                </div>
                <div className="is-size-4 has-text-dark-blue">
                    <Translate value="assessments.beginWarning2" />
                </div>
            </div>
        </AssessmentShell>
    );
};
